<template>
  <v-app>
    <!-- Keyboard users skip the sidebar's ~30 stops and land on the page itself. -->
    <a href="#main-content" class="skip-link" data-testid="skip-to-content">Skip to content</a>
    <!-- Navigation Drawer - Collapsible with Icon Mode -->
    <v-navigation-drawer
      v-model="drawer"
      app
      color="#FFFFFF"
      :width="isExtraSmallScreen ? 211 : isExpanded ? 211 : 64"
      :permanent="!isExtraSmallScreen"
      :temporary="isExtraSmallScreen"
      class="adx-sidebar"
      :class="{ 'sidebar-collapsed': !showFullNav }"
      @mouseleave="handleMouseLeave"
    >
      <!-- TOP: Logo + Toggle (non-scrollable) -->
      <template #prepend>
        <div class="sidebar-header" :class="{ 'sidebar-header-collapsed': !showFullNav }">
          <transition name="fade" mode="out-in">
            <router-link
              v-if="showFullNav"
              key="full-logo"
              to="/admin/dashboard"
              class="sidebar-logo"
              aria-label="Tattle ADX dashboard"
            >
              <svg
                class="sidebar-logo-image"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 700 235"
              >
                <g transform="translate(0,235) scale(0.1,-0.1)" fill="currentColor" stroke="none">
                  <path
                    d="M5152 2238 l3 -113 94 -7 c484 -37 934 -409 1102 -910 32 -94 69 -266 69 -318 l0 -29 110 -3 c129 -4 119 -19 94 149 -98 661 -511 1133 -1126 1288 -86 21 -287 54 -336 55 -10 0 -12 -26 -10 -112z"
                  />
                  <path
                    d="M5152 1744 l3 -109 60 -7 c376 -41 641 -314 710 -730 l6 -38 110 0 110 0 -7 53 c-35 297 -181 565 -396 728 -146 110 -349 189 -530 206 l-69 6 3 -109z"
                  />
                  <path
                    d="M0 1107 c0 -486 4 -753 11 -792 22 -117 95 -211 202 -260 51 -23 179 -45 264 -45 l43 0 0 99 0 100 -57 6 c-105 11 -120 15 -163 46 -74 54 -74 52 -74 509 l-1 405 148 3 147 3 0 104 0 105 -150 0 -150 0 0 225 0 225 -110 0 -110 0 0 -733z"
                  />
                  <path
                    d="M2270 1107 c0 -486 4 -753 11 -792 21 -117 94 -211 199 -259 54 -24 179 -46 267 -46 l43 0 0 99 0 100 -57 6 c-105 11 -120 15 -163 46 -74 54 -74 52 -78 512 l-4 407 151 0 151 0 0 105 0 105 -150 0 -150 0 0 225 0 225 -110 0 -110 0 0 -733z"
                  />
                  <path
                    d="M3087 1833 c-11 -11 -8 -1420 3 -1498 6 -38 22 -93 36 -122 32 -66 109 -136 180 -162 51 -19 188 -41 262 -41 l32 0 0 99 c0 112 1 111 -91 111 -57 0 -141 41 -171 82 -18 26 -22 51 -29 162 -10 163 -11 488 -2 619 l6 97 144 0 143 0 0 105 0 104 -147 3 -148 3 -3 223 -2 222 -104 0 c-56 0 -106 -3 -109 -7z"
                  />
                  <path d="M3880 940 l0 -900 110 0 110 0 0 900 0 900 -110 0 -110 0 0 -900z" />
                  <path
                    d="M1268 1409 c-92 -12 -215 -59 -296 -113 -372 -247 -424 -763 -110 -1077 58 -58 158 -125 233 -156 222 -93 520 -52 675 93 l50 47 0 -82 0 -81 106 0 105 0 -3 413 -3 412 -28 80 c-111 316 -409 505 -729 464z m156 -229 c171 -28 321 -161 370 -329 20 -67 21 -198 2 -267 -60 -225 -287 -373 -513 -334 -102 17 -184 59 -258 133 -133 133 -175 308 -114 484 63 185 228 307 434 321 11 1 46 -2 79 -8z"
                  />
                  <path
                    d="M4912 1409 c-342 -44 -613 -351 -612 -693 0 -114 22 -207 74 -311 92 -185 227 -305 421 -371 69 -24 96 -28 195 -28 136 0 209 16 325 74 152 75 252 175 326 326 21 44 39 86 39 92 0 9 -33 12 -114 12 l-114 0 -22 -34 c-33 -55 -134 -142 -202 -175 -94 -46 -205 -67 -295 -54 -177 25 -330 153 -377 312 -9 30 -16 58 -16 63 0 4 264 8 587 8 l586 0 -6 98 c-20 313 -167 532 -427 634 -111 44 -253 62 -368 47z m238 -245 c132 -37 244 -125 299 -235 17 -34 31 -68 31 -76 0 -11 -83 -13 -466 -13 l-466 0 7 28 c13 56 54 129 99 179 111 123 308 169 496 117z"
                  />
                  <path
                    d="M6851 994 c-44 -56 -8 -134 61 -134 76 1 115 84 63 135 -35 36 -96 35 -124 -1z m109 -6 c57 -61 -28 -149 -90 -93 -41 37 -11 115 45 115 13 0 33 -10 45 -22z"
                  />
                  <path
                    d="M6880 941 c0 -23 5 -41 10 -41 6 0 10 7 10 15 0 8 7 15 15 15 8 0 15 -7 15 -15 0 -8 4 -15 9 -15 6 0 9 17 8 38 -3 34 -6 37 -35 40 -31 3 -32 2 -32 -37z m50 19 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z"
                  />
                </g>
              </svg>
            </router-link>
          </transition>

          <!-- Toggle button - only shown in collapsed mode, centered in header -->
          <WButton
            v-if="!isExtraSmallScreen && !showFullNav"
            :icon="mdiMenuClose"
            variant="icon"
            class="nav-toggle-btn"
            label="Expand the menu"
            section-tag="nav-toggle"
            @click="toggleSidebar"
          />
        </div>

        <v-divider class="mx-3 mb-2" />
      </template>

      <!-- MIDDLE: Scrollable nav items -->
      <div class="nav-list" @mouseenter="handleMouseEnter">
        <template v-for="item in navigationItems" :key="item.title">
          <!-- Group with children -->
          <template v-if="item.children">
            <!-- Collapsed: icon-only with tooltip -->
            <WTooltip v-if="!showFullNav" :description="item.title" position="right">
              <button
                class="nav-item nav-item-top nav-item-collapsed"
                :aria-label="item.title"
                @click="handleParentClick"
              >
                <v-icon :icon="item.icon" size="14" />
              </button>
            </WTooltip>
            <!-- Expanded: group header + collapsible children -->
            <template v-else>
              <button
                class="nav-item nav-item-top"
                :data-testid="`nav-group-${slugify(item.title)}`"
                @click="toggleGroup(item)"
              >
                <v-icon :icon="item.icon" size="14" class="nav-item-icon" />
                <span class="nav-item-label">{{ item.title }}</span>
                <v-icon
                  :icon="mdiChevronDown"
                  size="14"
                  class="nav-item-chevron"
                  :class="{ 'nav-item-chevron-open': isGroupOpen(item) }"
                />
              </button>
              <template v-if="isGroupOpen(item)">
                <template v-for="(child, index) in item.children" :key="child.title">
                <div
                  v-if="startsSection(item.children, index)"
                  class="nav-section-heading"
                  :data-testid="`nav-section-${slugify(child.section ?? '')}`"
                >
                  {{ child.section }}
                </div>
                <router-link
                  :to="childTarget(child)"
                  custom
                  v-slot="{ isActive, navigate }"
                >
                  <button
                    class="nav-item nav-item-nested"
                    :class="{ 'nav-item-active': isChildActive(child, isActive) }"
                    :data-testid="`nav-${slugify(child.title)}`"
                    @click="navigate(); handleNavClick()"
                  >
                    <span class="nav-item-label">{{ child.title }}</span>
                    <span
                      v-if="child.title === 'Test Inbox' && testInboxUnreadCount > 0"
                      class="nav-item-badge"
                      data-testid="nav-inbox-unread"
                    >
                      {{ testInboxUnreadCount > 99 ? '99+' : testInboxUnreadCount }}
                    </span>
                    <span
                      v-if="child.title === 'Needs attention' && attentionBadgeCount > 0"
                      class="nav-item-badge"
                      :title="NEEDS_ATTENTION_BADGE_HELP"
                      data-testid="nav-needs-attention-badge"
                    >
                      {{ attentionBadgeText }}
                    </span>
                    <span
                      v-if="child.title === 'My work' && myWorkBadgeCount > 0"
                      class="nav-item-badge"
                      :title="MY_WORK_BADGE_HELP"
                      data-testid="nav-my-work-badge"
                    >
                      {{ myWorkBadgeText }}
                    </span>
                  </button>
                </router-link>
                </template>
              </template>
            </template>
          </template>

          <!-- Regular leaf item -->
          <template v-else>
            <!-- Collapsed: icon-only with tooltip -->
            <WTooltip v-if="!showFullNav" :description="item.title" position="right">
              <router-link :to="item.to ?? '/'" custom v-slot="{ isActive, navigate }">
                <button
                  class="nav-item nav-item-top nav-item-collapsed"
                  :class="{ 'nav-item-active': isActive }"
                  :aria-label="item.title"
                  :aria-current="isActive ? 'page' : undefined"
                  @click="navigate()"
                >
                  <v-icon :icon="item.icon" size="14" />
                </button>
              </router-link>
            </WTooltip>
            <!-- Expanded: icon + label -->
            <router-link v-else :to="item.to ?? '/'" custom v-slot="{ isActive, navigate }">
              <button
                class="nav-item nav-item-top"
                :class="{ 'nav-item-active': isActive }"
                @click="navigate(); handleNavClick()"
              >
                <v-icon :icon="item.icon" size="14" class="nav-item-icon" />
                <span class="nav-item-label">{{ item.title }}</span>
              </button>
            </router-link>
          </template>
        </template>
      </div>

      <!-- BOTTOM: Profile card + Logout (non-scrollable) -->
      <template #append>
        <v-divider class="mx-3 mt-1" />

        <div class="sidebar-bottom">
          <!-- The engineer's own runner, a card like the profile below it -->
          <ClaudeRunnerCard
            v-if="authStore.isAuthenticated && !authStore.isImpersonating"
            class="sidebar-runner-card"
            :class="{ 'sidebar-runner-card-collapsed': !showFullNav }"
            section-tag="sidebar-runner"
          />
          <!-- Profile Card - click to open display settings -->
          <v-menu location="top start" :close-on-content-click="false">
            <template #activator="{ props: menuProps }">
              <WTooltip v-if="!showFullNav" :description="userEmail" position="right">
                <div
                  v-bind="menuProps"
                  class="profile-button-card profile-button-card-collapsed"
                >
                  <div class="profile-avatar">{{ profileInitial }}</div>
                </div>
              </WTooltip>
              <div v-else v-bind="menuProps" class="profile-button-card">
                <div class="profile-avatar">{{ profileInitial }}</div>
                <span class="profile-email">{{ userEmail }}</span>
              </div>
            </template>

            <v-list density="compact" min-width="280">
              <v-list-subheader>Display Settings</v-list-subheader>
              <v-list-item
                :prepend-icon="mdiPalette"
                @click="uiSettingsStore.toggleEnvironmentBorder()"
              >
                <template #append>
                  <WSwitch
                    :model-value="uiSettingsStore.showEnvironmentBorder"
                    aria-label="Theme"
                    hide-details
                    @click.stop
                    @update:model-value="uiSettingsStore.toggleEnvironmentBorder()"
                  />
                </template>
                <v-list-item-title>Theme</v-list-item-title>
                <!-- The switch keeps the admin's own setting; the theme turns off again on Default -->
                <v-list-item-subtitle
                  v-if="!uiSettingsStore.showEnvironmentBorder && uiSettingsStore.isDashboardTargeted"
                  data-testid="user-menu-theme-target-hint"
                >
                  On in Violet while a dashboard target is set
                </v-list-item-subtitle>
              </v-list-item>
              <RunnerCardMenuItem />
              <!-- Color Selection (only when theme is enabled) -->
              <v-list-item
                v-if="uiSettingsStore.showEnvironmentBorder"
                :prepend-icon="mdiSwapHorizontal"
                class="color-picker-item"
              >
                <v-list-item-title class="d-flex align-center gap-2">
                  Color
                  <div class="color-swatches">
                    <button
                      v-for="color in colorOptions"
                      :key="color.value"
                      type="button"
                      class="color-swatch"
                      :class="{ 'color-swatch-selected': currentEnvColor === color.value }"
                      :style="{ backgroundColor: `rgb(${color.cssVar})` }"
                      :title="color.label"
                      @click.stop="setEnvColor(color.value)"
                    />
                  </div>
                </v-list-item-title>
                <!-- The swatches keep the admin's own colour selected; it returns on Default -->
                <v-list-item-subtitle
                  v-if="uiSettingsStore.isDashboardTargeted"
                  data-testid="user-menu-color-target-hint"
                >
                  Violet while a dashboard target is set
                </v-list-item-subtitle>
              </v-list-item>
              <!-- Dashboard target (dev and staging only) -->
              <v-list-item
                v-if="uiSettingsStore.isDashboardTargetSupported"
                :prepend-icon="mdiMonitorDashboard"
                data-testid="user-menu-dashboard-target"
                @click="showDashboardTargetPicker = true"
              >
                <v-list-item-title>Dashboard target</v-list-item-title>
                <v-list-item-subtitle data-testid="user-menu-dashboard-target-value">
                  {{ dashboardTargetLabel }}
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item v-if="canImpersonate" :prepend-icon="mdiAccountSwitch">
                <v-list-item-title class="d-flex align-center" style="gap: 12px">
                  <span>Impersonate Duration</span>
                  <ButtonToggle
                    v-model="uiSettingsStore.impersonationDuration"
                    :options="durationOptions"
                    density="compact"
                    size="x-small"
                    custom-class="duration-toggle"
                    section-tag="impersonate-duration-toggle"
                  />
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Logout -->
          <WTooltip v-if="!showFullNav" description="Logout" position="right">
            <button class="nav-item nav-item-top nav-item-collapsed" aria-label="Logout" @click="handleLogout">
              <v-icon :icon="mdiLogout" size="14" />
            </button>
          </WTooltip>
          <button v-else class="nav-item nav-item-top" @click="handleLogout">
            <v-icon :icon="mdiLogout" size="14" class="nav-item-icon" />
            <span class="nav-item-label">Logout</span>
          </button>
        </div>

        <!-- Version Info -->
        <div
          v-if="environmentInfo"
          class="version-footer"
          :class="{ 'version-footer-collapsed': !showFullNav }"
        >
          <span class="version-text">{{ environmentInfo.deployedVersion }}</span>
        </div>
      </template>
    </v-navigation-drawer>

    <!--
      The two floating buttons are fixed to the window, but WButton wraps each in a tooltip span that
      stays in the page flow; this frame takes it out, or the content below starts 40px down and every
      page scrolls 40px past the window.
    -->
    <div class="floating-controls">
      <!-- Sidebar border toggle - floating circle on right edge when expanded -->
      <WButton
        v-if="!isExtraSmallScreen && showFullNav"
        :icon="mdiMenuOpen"
        variant="icon"
        class="sidebar-border-toggle"
        label="Collapse the menu"
        section-tag="sidebar-border-toggle"
        @click="toggleSidebar"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      />

      <!-- Mobile Menu Button - floating, only on xs when drawer is closed -->
      <WButton
        v-if="isExtraSmallScreen && !drawer"
        :icon="mdiMenu"
        variant="icon"
        class="mobile-menu-btn"
        label="Open the menu"
        section-tag="mobile-menu"
        @click="drawer = true"
      />
    </div>

    <!-- Main Content -->
    <v-main id="main-content" tabindex="-1" style="background-color: #f9fafb">
      <!-- Admin Impersonation Banner - sticky inside scroll area -->
      <v-banner
        v-if="authStore.isImpersonating"
        :class="['admin-impersonation-banner', environmentBannerClass]"
        :stacked="false"
        density="compact"
      >
        <template #prepend>
          <DecorativeIcon :icon="mdiAccountSwitch" />
        </template>
        <v-banner-text>
          <WPills
            type="static"
            size="small"
            :color="environmentPillColor"
            :label="environment"
            section-tag="impersonation-banner-environment"
            class="mr-2"
          />
          <strong>Impersonating:</strong> {{ authStore.impersonatedAdmin?.displayName }} ({{
            authStore.impersonatedAdmin?.email
          }})
          <span v-if="impersonationTimeRemaining" class="ml-2 text-caption">
            &bull; {{ impersonationTimeRemaining }}
          </span>
        </v-banner-text>
        <template #actions>
          <WButton
            variant="secondary"
            size="small"
            :loading="isEndingImpersonation"
            label="End Impersonation"
            section-tag="impersonation-banner-end"
            @click="handleEndImpersonation"
          />
        </template>
      </v-banner>

      <DashboardTargetIndicator v-if="uiSettingsStore.isDashboardTargetSupported" />

      <router-view />
    </v-main>
  </v-app>

  <!-- Global Toast Notification - Outside v-app for proper positioning -->
  <WToastNotification
    v-model="toastState.show"
    :type="toastState.type"
    :title="toastState.title"
    :description="toastState.description"
    :section-tag="toastState.sectionTag"
    closable
  />

  <!-- Global Confirmation Modal -->
  <ConfirmModal />

  <!-- A ticket's timeline, opened by key from any page; mounted only while one is open -->
  <TicketTimelineDrawer v-if="ticketTimelineStore.isOpen" />

  <DashboardTargetPicker
    v-if="uiSettingsStore.isDashboardTargetSupported"
    v-model="showDashboardTargetPicker"
  />
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useDisplay } from 'vuetify'
import { useAuthStore } from '@/stores/auth.store'
import { useLayoutStore } from '@/stores/layout.store'
import { useTicketTimelineStore } from '@/stores/ticket-timeline.store'
import { usePermissions } from '@/composables/usePermissions'
import { useToast } from '@/composables/useToast'
import { useEnvironmentInfo } from '@/composables/useEnvironmentInfo'
import { useMyWorkBadge } from '@/composables/useMyWorkBadge'
import { childTarget, startsSection, useSidebarGroups } from '@/composables/useSidebarGroups'
import { NEEDS_ATTENTION_BADGE_HELP, useNeedsAttentionBadge } from '@/composables/useNeedsAttentionBadge'

import colors from '@/plugins/vuetify/colors.mjs'
import { AdminPermission } from '@/services/administrator-permissions'
import type { EnvironmentColorOption } from '@/types/ui-settings.types'

import WButton from '@wasabi/actions/WButton.vue'
import WPills from '@wasabi/actions/WPills.vue'
import WSwitch from '@wasabi/inputs/WSwitch.vue'
import WToastNotification from '@wasabi/feedback/WToastNotification.vue'
import WTooltip from '@wasabi/data-visualization/WTooltip.vue'

import ConfirmModal from '@/components/shared/ConfirmModal.vue'
import ClaudeRunnerCard from '@/components/shared/ClaudeRunnerCard.vue'
import RunnerCardMenuItem from '@/views/RunnerCardMenuItem.vue'
import TicketTimelineDrawer from '@/components/shared/TicketTimelineDrawer.vue'
import DecorativeIcon from '@/components/shared/DecorativeIcon.vue'
import ButtonToggle from '@/components/shared/ButtonToggle.vue'
import DashboardTargetIndicator from '@/components/dashboard-target/DashboardTargetIndicator.vue'
import DashboardTargetPicker from '@/components/dashboard-target/DashboardTargetPicker.vue'
import { useUiSettingsStore, colorOptions } from '@/stores/ui-settings.store'
import { useEmailTestingStore } from '@/services/test-inbox'
import { useSmsTestingStore } from '@/services/test-inbox'
import { useInboxReadState } from '@/composables/useInboxReadState'
import { slugify } from '@/composables/useDataTestid'
import { useSmsReadState } from '@/composables/useSmsReadState'

import { filterNavigationItems } from '@/utils/navigationFilter'
import {
  getEnvironmentBannerColor,
  getEnvironmentLabel,
  getEnvironmentPillColor
} from '@/utils/environmentUtils'
import type { NavigationItem } from '@/utils/navigationFilter'
import {
  mdiViewDashboard,
  mdiAccountGroup,
  mdiTagMultiple,
  mdiEmailOutline,
  mdiBellOutline,
  mdiStore,
  mdiLogout,
  mdiAccountSwitch,
  mdiHandshake,
  mdiReceiptText,
  mdiReceiptTextPlus,
  mdiQrcode,
  mdiImageMultiple,
  mdiCog,
  mdiFileDocumentMultiple,
  mdiCogOutline,
  mdiChartBox,
  mdiChevronDown,
  mdiMenu,
  mdiMenuClose,
  mdiMenuOpen,
  mdiApi,
  mdiFileDocument,
  mdiCashMultiple,
  mdiCellphone,
  mdiCurrencyUsd,
  mdiWebhook,
  mdiMagnify,
  mdiPhoneOff,
  mdiCommentAlertOutline,
  mdiTestTube,
  mdiFlaskOutline,
  mdiShareVariant,
  mdiWrench,
  mdiSend,
  mdiMonitorDashboard,
  mdiPalette,
  mdiSwapHorizontal,
  mdiStorefront,
  mdiBroom,
  mdiAccountClock,
  mdiPlay,
  mdiShieldAccount,
  mdiEmail,
  mdiEmailSearchOutline,
  mdiRobot,
  mdiRobotOutline,
  mdiConsoleLine,
  mdiChartBar,
  mdiTranslate,
  mdiDatabaseSyncOutline,
  mdiShieldLockOutline,
  mdiClipboardTextOutline,
  mdiClipboardAccountOutline,
  mdiPackageVariantClosedCheck,
  mdiClipboardCheckOutline,
  mdiScoreboardOutline,
  mdiAccountMultipleOutline,
  mdiShieldSearch,
  mdiCheckDecagramOutline,
  mdiChartLine,
  mdiToolboxOutline,
  mdiAccountCogOutline,
  mdiLightbulbOnOutline,
  mdiSourcePull,
  mdiMapMarker
} from '@mdi/js'

const router = useRouter()

// Test Inbox unread count — messages in the store that haven't been read.
// The store only refreshes while the user is on the inbox (or live-tail is
// on), so the badge naturally stays quiet otherwise. Zero by default until
// the store is populated; displayed as "99+" beyond 99 to keep the nav tight.
const emailTestingStore = useEmailTestingStore()
const smsTestingStore = useSmsTestingStore()
const { readIds: inboxReadIds } = useInboxReadState()
const { isRead: isSmsRead } = useSmsReadState()
// Combined unread badge for the unified Test Inbox nav item — email + SMS.
const testInboxUnreadCount = computed(() => {
  const email = emailTestingStore.messages.filter(
    (m: { id: string }) => !inboxReadIds.value.has(m.id)
  ).length
  const sms = smsTestingStore.messages.filter(
    (m: { id: string }) => !isSmsRead(m.id)
  ).length
  return email + sms
})

const { count: myWorkBadgeCount, text: myWorkBadgeText } = useMyWorkBadge()
const { count: attentionBadgeCount, text: attentionBadgeText } = useNeedsAttentionBadge()
const MY_WORK_BADGE_HELP = 'Your PRs ready to merge plus decisions waiting on you'

/** A Claude group entry that opens one section of the Fleet page. */
function fleetTab(title: string, hash: string, section: string): NavigationItem {
  return { title, icon: mdiRobotOutline, to: '/admin/tools/claude-fleet', permission: null, section, hash }
}

const { isGroupOpen, toggleGroup, isChildActive, resetGroups } = useSidebarGroups()

const authStore = useAuthStore()
const layoutStore = useLayoutStore()
const uiSettingsStore = useUiSettingsStore()
const ticketTimelineStore = useTicketTimelineStore()
const display = useDisplay()
const { state: toastState } = useToast()
const { can, isSuperAdmin } = usePermissions()
const { environmentInfo } = useEnvironmentInfo()

// Permissions
const canImpersonate = can(AdminPermission.UserImpersonate)

// Button toggle options
const durationOptions = [
  { value: 15, label: '15m' },
  { value: 30, label: '30m' },
  { value: 60, label: '60m' },
  { value: 120, label: '2h' }
]

// Admin impersonation state
const isEndingImpersonation = ref(false)

// Dashboard target picker
const showDashboardTargetPicker = ref(false)
const dashboardTargetLabel = computed(() => {
  const target = uiSettingsStore.activeDashboardTarget
  if (target.kind === 'deployment') return target.branch
  if (target.kind === 'local') return 'Local dev'
  return 'Default'
})

/**
 * The banner is colour-coded by environment so prod is unmistakable, and always renders the
 * environment name alongside it — colour on its own is not a signal every reader can use.
 *
 * The wash is a tonal treatment (saturated text/icon over a muted background), not a solid
 * fill: v-banner has no `variant` prop, so `environmentBannerClass` selects one of three scoped
 * CSS rules below rather than a Vuetify colour prop. A solid fill was ruled out because this
 * banner ships to production with 13.18.0 — a full-width solid-red bar for an entire
 * impersonation session is a louder, more alarming treatment than the signal warrants.
 */
const environment = getEnvironmentLabel()
const environmentBannerColor = getEnvironmentBannerColor()
const environmentBannerClass = `admin-impersonation-banner--${environmentBannerColor}`
const environmentPillColor = getEnvironmentPillColor()

// Computed for impersonation expiration
const impersonationTimeRemaining = computed(() => {
  if (!authStore.isImpersonating || !authStore.impersonationExpires) return null
  const expiresDate = new Date(authStore.impersonationExpires)
  const now = new Date()
  const diffMs = expiresDate.getTime() - now.getTime()
  if (diffMs <= 0) return 'Expired'
  const diffMins = Math.floor(diffMs / 60000)
  if (diffMins >= 60) {
    const hours = Math.floor(diffMins / 60)
    const mins = diffMins % 60
    return `${hours}h ${mins}m remaining`
  }
  return `${diffMins}m remaining`
})

// State
const drawer = ref(true)
const isExpanded = ref(true)
const isPinned = ref(true)

// Watch layout store for external collapse requests
watch(
  () => layoutStore.isNavCollapsed,
  collapsed => {
    if (collapsed && !isExtraSmallScreen.value) {
      // Collapse nav on tablet/desktop
      isExpanded.value = false
      isPinned.value = false
    } else if (collapsed && isExtraSmallScreen.value) {
      // Close drawer on mobile
      drawer.value = false
    }
    // Reset store state after applying
    if (collapsed) {
      layoutStore.isNavCollapsed = false
    }
  }
)

// Computed - check if on mobile device for auto-collapse behavior
const isMobile = computed(() => display.mobile.value)
const isExtraSmallScreen = computed(() => display.xs.value) // Extra small screens (< 600px)

// Show full nav (icons + labels) when expanded OR on xs screens (mobile drawer always shows full)
const showFullNav = computed(() => isExpanded.value || isExtraSmallScreen.value)

// Watch for mobile breakpoint changes and auto-collapse
watch(
  isMobile,
  newIsMobile => {
    if (newIsMobile) {
      // Switching to mobile - collapse to icon mode
      isExpanded.value = false
      isPinned.value = false
    } else {
      // Switching to desktop - expand and pin
      isExpanded.value = true
      isPinned.value = true
    }
  },
  { immediate: true }
)

// Watch for extra small screen and close drawer by default
watch(
  isExtraSmallScreen,
  newIsXs => {
    if (newIsXs) {
      // On xs screens, drawer starts closed (temporary mode)
      drawer.value = false
    } else {
      // On larger screens, drawer is always visible (permanent mode)
      drawer.value = true
    }
  },
  { immediate: true }
)

// Check if running in production
const isProduction = computed(() => import.meta.env.MODE === 'production')

// Navigation items with permissions
const allNavigationItems: NavigationItem[] = [
  {
    title: 'Dashboard',
    icon: mdiViewDashboard,
    to: '/admin/dashboard',
    permission: null // Dashboard accessible to all
  },
  {
    title: 'Merchants',
    icon: mdiStore,
    to: '/admin/merchants',
    permission: AdminPermission.MerchantsView
  },
  {
    title: 'Partners API',
    icon: mdiApi,
    to: '/admin/partner-integrators',
    permission: AdminPermission.PartnerIntegratorsView
  },
  {
    title: 'Marketing Images',
    icon: mdiImageMultiple,
    to: '/admin/marketing-images',
    permission: AdminPermission.MarketingImagesView
  },
   {
    title: 'Reports',
    icon: mdiFileDocumentMultiple,
    to: '/admin/reports',
    permission: AdminPermission.ReportsView
  },
  {
    title: 'Search',
    icon: mdiMagnify,
    permission: null, // Group visible if any child is visible
    children: [
      {
        title: 'Orders',
        icon: mdiReceiptText,
        to: '/admin/orders',
        permission: AdminPermission.OrdersView
      },
      {
        title: 'User Logs',
        icon: mdiAccountClock,
        to: '/admin/user-logs',
        permission: AdminPermission.UserLogsView
      },
      {
        title: 'Webhook Logs',
        icon: mdiWebhook,
        to: '/admin/webhook-logs',
        permission: AdminPermission.WebhookLogsView
      },
      {
        title: 'Audit Logs',
        icon: mdiFileDocument,
        to: '/admin/audit-logs',
        permission: AdminPermission.AuditLogsView
      },
      {
        title: 'Automation Runs',
        icon: mdiRobot,
        to: '/admin/automation-runs',
        permission: AdminPermission.AutomationRunsView
      },
      {
        title: 'Social Media Audit',
        icon: mdiChartBar,
        to: '/admin/social-media/review-audit',
        permission: AdminPermission.SocialMediaReviewAuditView
      },
      {
        title: 'Chatmeter Locations',
        icon: mdiMapMarker,
        to: '/admin/social-media/chatmeter-locations',
        permission: AdminPermission.SocialMediaChatmeterLocationsView
      }
    ]
  },
  {
    title: 'Billing',
    icon: mdiCashMultiple,
    permission: null, // Group visible if any child is visible
    children: [
      {
        title: 'Merchant Fees',
        icon: mdiCurrencyUsd,
        to: '/admin/billing/merchant-fees',
        permission: AdminPermission.BillingRatesView
      },
      {
        title: 'SMS Billing',
        icon: mdiCellphone,
        to: '/admin/billing/sms',
        permission: AdminPermission.SmsBillingView
      }
    ]
  },
  {
    // "Email" is the merchant-admin view backed by Mandrill (prod) /
    // Mailosaur (dev/staging): sent messages, rejects, allowlist, sender
    // domains. Owned by Anthony A. (src/views/email/, Feb 2026).
    //
    // The separate "Test Inbox" item under Developer Tools is a different
    // thing — a dev/staging-only viewer over the in-house tattle-inbox
    // sink that RECEIVES test mail. Both features are intentional; they
    // answer different questions (what did we send? vs what did our test
    // sink receive?). See TE-12753.
    title: 'Email',
    icon: mdiEmail,
    permission: null, // Group visible if any child is visible
    children: [
      {
        title: 'Emails',
        icon: mdiEmailOutline,
        to: '/admin/email',
        permission: AdminPermission.EmailMessagesView
      },
      {
        title: 'Feedback Requests',
        icon: mdiBellOutline,
        to: '/admin/feedback-requests',
        permission: AdminPermission.EmailMessagesView
      }
    ]
  },
  {
    title: 'Privacy',
    icon: mdiShieldLockOutline,
    permission: null, // Group visible if any child is visible
    children: [
      {
        title: 'Data Subject Requests',
        icon: mdiClipboardTextOutline,
        to: '/admin/data-subject-requests',
        permission: AdminPermission.DataSubjectRequestsView
      }
    ]
  },
  {
    title: 'App Configuration',
    icon: mdiCogOutline,
    permission: null, // Group visible if any child is visible
    children: [
      {
        title: 'Merchant Types',
        icon: mdiTagMultiple,
        to: '/admin/merchant-types',
        permission: AdminPermission.MerchantsView
      },
      {
        title: 'Partners',
        icon: mdiHandshake,
        to: '/admin/partners',
        permission: AdminPermission.PartnersView
      },
      {
        title: 'Preferences',
        icon: mdiCog,
        to: '/admin/preferences',
        permission: AdminPermission.PreferencesView
      },
      {
        title: 'Feedback Request Defaults',
        icon: mdiTranslate,
        to: '/admin/message-template-defaults',
        permission: AdminPermission.MessageTemplateDefaultsView
      },
      {
        title: 'Metabase',
        icon: mdiChartBox,
        to: '/admin/metabase',
        permission: AdminPermission.MetabaseDashboardsView
      },
      {
        title: 'SMS Blacklist',
        icon: mdiPhoneOff,
        to: '/admin/sms-blacklist',
        permission: AdminPermission.SmsBlacklistManage
      },
      {
        title: 'Reply Error Config',
        icon: mdiCommentAlertOutline,
        to: '/admin/social-media-reply-error-config',
        permission: AdminPermission.SocialMediaReplyErrorConfigManage
      },
      {
        title: 'Social Media',
        icon: mdiShareVariant,
        to: '/admin/social-media/resync'
      }
    ]
  },
  {
    title: 'Administration',
    icon: mdiCog,
    permission: null, // Group visible if any child is visible
    children: [
      {
        title: 'Administrators',
        icon: mdiAccountGroup,
        to: '/admin/administrators',
        permission: AdminPermission.AdministratorsView
      },
      {
        title: 'Permissions',
        icon: mdiShieldAccount,
        to: '/admin/permissions',
        permission: AdminPermission.PermissionsView
      }
    ]
  },
  {
    // Pages over tattle-claude-fleet's /fleet API, which works out the person from the caller's token
    // and does its own staff check, so none carries an ADX permission. Not listed in production yet; the
    // pages still open from a direct link.
    title: 'Claude',
    icon: mdiRobotOutline,
    permission: null,
    hideInProduction: true,
    children: [
      {
        title: 'Needs attention',
        icon: mdiAccountMultipleOutline,
        to: '/admin/tools/needs-attention',
        permission: null,
        section: 'My work',
        routeName: 'claude-needs-attention'
      },
      {
        title: 'My work',
        icon: mdiClipboardAccountOutline,
        to: '/admin/tools/my-work',
        permission: null,
        section: 'My work'
      },
      {
        title: 'QA queue',
        icon: mdiClipboardCheckOutline,
        to: '/admin/tools/qa-queue',
        permission: null,
        section: 'Queues',
        routeName: 'qa-queue'
      },
      {
        title: 'QWE scoreboard',
        icon: mdiScoreboardOutline,
        to: '/admin/tools/qwe-scoreboard',
        permission: null,
        section: 'Queues',
        routeName: 'claude-qwe-scoreboard'
      },
      fleetTab('Waiting work', '#queue', 'Queues'),
      fleetTab('Delivery queue', '#delivery', 'Queues'),
      {
        title: 'Releases',
        icon: mdiPackageVariantClosedCheck,
        to: '/admin/tools/releases',
        permission: null,
        section: 'Shipping'
      },
      {
        title: 'Pull requests',
        icon: mdiSourcePull,
        to: '/admin/tools/pull-requests',
        permission: null,
        section: 'Shipping',
        routeName: 'claude-repo-prs'
      },
      {
        title: 'Pipelines',
        icon: mdiRobotOutline,
        to: '/admin/tools/pipelines',
        permission: null,
        section: 'Shipping',
        routeName: 'claude-pipelines'
      },
      {
        title: 'Tests',
        icon: mdiCheckDecagramOutline,
        to: '/admin/tools/tests',
        permission: null,
        section: 'Shipping',
        routeName: 'claude-tests'
      },
      fleetTab('Overview', '#overview', 'Fleet'),
      fleetTab('Runs', '#runs', 'Fleet'),
      fleetTab('Runners', '#runners', 'Fleet'),
      fleetTab('Loops', '#loops', 'Fleet'),
      {
        title: 'Metrics',
        icon: mdiChartLine,
        to: '/admin/tools/metrics',
        permission: null,
        section: 'Fleet',
        routeName: 'claude-metrics'
      },
      fleetTab('Costs', '#costs', 'Fleet'),
      fleetTab('Audit', '#audit', 'Fleet'),
      {
        title: 'Oversight',
        icon: mdiShieldSearch,
        to: '/admin/tools/oversight',
        permission: null,
        section: 'Oversight',
        routeName: 'claude-oversight'
      },
      fleetTab('Fleet settings', '#settings', 'Setup'),
      {
        title: 'Team settings',
        icon: mdiAccountCogOutline,
        to: '/admin/tools/team-settings',
        permission: null,
        section: 'Setup',
        routeName: 'claude-team-settings'
      },
      {
        title: 'Claude tools',
        icon: mdiToolboxOutline,
        to: '/admin/tools/claude-tools',
        permission: null,
        section: 'Setup',
        routeName: 'claude-tools'
      },
      {
        title: 'Wishlist',
        icon: mdiLightbulbOnOutline,
        to: '/admin/tools/wishlist',
        permission: null,
        section: 'Setup',
        routeName: 'claude-wishlist'
      }
    ]
  },
  {
    title: 'Tools',
    icon: mdiWrench,
    permission: null, // Group visible if any child is visible
    children: [
      {
        title: 'Data Replication',
        icon: mdiDatabaseSyncOutline,
        to: '/admin/data-replication',
        permission: AdminPermission.DataReplicationView
      },
      {
        title: 'Test Executions',
        icon: mdiTestTube,
        to: '/admin/test-executions',
        permission: AdminPermission.TestExecutionsView,
        hideInProduction: true
      },
      {
        // Offline LLM eval results published to the evaluations bucket. Dev/staging only —
        // the bucket and the eval runs live in dev.
        title: 'LLM Evaluations',
        icon: mdiFlaskOutline,
        to: '/admin/evaluations',
        permission: AdminPermission.EvaluationsView,
        hideInProduction: true
      },
      {
        title: 'Run Tests',
        icon: mdiPlay,
        to: '/admin/tools/run-tests',
        permission: AdminPermission.RunTests,
        hideInProduction: true
      },
      {
        title: 'Send Orders',
        icon: mdiReceiptText,
        to: '/admin/tools/send-orders',
        permission: AdminPermission.SendOrders
      },
      {
        title: 'Generate Receipt',
        icon: mdiReceiptTextPlus,
        to: '/admin/tools/generate-receipt',
        // Open to any TattleAdmin. The page builds an image client-side; every piece of real
        // data it reads is gated on its own permission (orders on OrdersView, and so on).
        permission: null
      },
      {
        title: 'Generate QR Code',
        icon: mdiQrcode,
        to: '/admin/tools/generate-qr-code',
        // Open to any TattleAdmin. Saving a style is the gated action, not opening the page.
        permission: null
      },
      {
        title: 'Send Events',
        icon: mdiSend,
        to: '/admin/tools/send-events',
        permission: AdminPermission.SendEvents,
        hideInProduction: true
      },
      {
        title: 'Add Merchant',
        icon: mdiStore,
        to: '/admin/tools/add-merchant',
        permission: AdminPermission.AddMerchant,
        hideInProduction: true
      },
      {
        title: 'Cleanup Merchant',
        icon: mdiBroom,
        to: '/admin/tools/cleanup-merchant',
        permission: AdminPermission.CleanupMerchant,
        hideInProduction: true
      },
      {
        title: 'Partner Console',
        icon: mdiConsoleLine,
        to: '/admin/tools/partner-console',
        // Shown in production too — see the route's note in router/index.ts. Gated on the
        // permission alone, which today only super admins hold.
        permission: AdminPermission.PartnerImpersonate
      },
      {
        title: 'Mobile Simulator',
        icon: mdiCellphone,
        to: '/admin/mobile-simulator',
        permission: AdminPermission.MobileSimulatorAccess
      },
      {
        // Unified viewer over the in-house tattle-inbox sink — one merged
        // email + SMS timeline for Playwright + manual QA. Dev/staging only.
        // No permission gate because ADX is already Okta-protected and the
        // sink authenticates itself. Distinct from the top-level "Email"
        // (Anthony's Mandrill/Mailosaur admin UI). See TE-12753.
        title: 'Test Inbox',
        icon: mdiEmailSearchOutline,
        to: '/admin/test-inbox',
        permission: null,
        hideInProduction: true
      }
    ]
  }
]

// Filter navigation items based on permissions
const navigationItems = computed(() =>
  filterNavigationItems(allNavigationItems, {
    isProduction: isProduction.value,
    isSuperAdmin: isSuperAdmin.value,
    hasPermission: permission => can(permission).value,
    hasRoute: name => router.hasRoute(name)
  })
)

const userEmail = computed(() => {
  return authStore.user?.email || 'Admin User'
})

const profileInitial = computed(() => {
  const email = authStore.user?.email
  if (email) return email[0].toUpperCase()
  return 'A'
})

// Environment color settings: the swatches show the admin's saved choice, not the Violet override
const currentEnvColor = computed(() => uiSettingsStore.savedEnvColor)

const setEnvColor = (color: EnvironmentColorOption) => {
  const env = uiSettingsStore.currentEnvironment
  switch (env) {
    case 'DEV':
      uiSettingsStore.devColor = color
      break
    case 'STAGING':
      uiSettingsStore.stagingColor = color
      break
    case 'PROD':
      uiSettingsStore.prodColor = color
      break
  }
}

// Methods
const toggleSidebar = () => {
  // On extra small screens, toggle the drawer visibility
  if (isExtraSmallScreen.value) {
    drawer.value = !drawer.value
    return
  }
  // Toggle pin/expand state (works same on mobile and desktop)
  isPinned.value = !isPinned.value
  isExpanded.value = isPinned.value
}

let collapseTimer: ReturnType<typeof setTimeout> | null = null

const handleMouseEnter = () => {
  if (collapseTimer) {
    clearTimeout(collapseTimer)
    collapseTimer = null
  }
  if (!isPinned.value) {
    isExpanded.value = true
  }
}

const handleMouseLeave = () => {
  if (!isPinned.value) {
    collapseTimer = setTimeout(() => {
      isExpanded.value = false
      collapseTimer = null
    }, 200)
  }
}

const handleNavClick = () => {
  resetGroups()
  // On extra small screens, close the drawer after navigation
  if (isExtraSmallScreen.value) {
    drawer.value = false
    return
  }
  // On mobile, collapse to icon mode after navigation
  if (isMobile.value && !isPinned.value) {
    isExpanded.value = false
  }
}

const handleParentClick = () => {
  // On mobile when collapsed, expand to show children
  if (isMobile.value && !isExpanded.value) {
    isExpanded.value = true
  }
}

const handleLogout = async () => {
  await authStore.logout()
  router.push('/admin/login')
}

const handleEndImpersonation = async () => {
  isEndingImpersonation.value = true
  try {
    await authStore.endImpersonation()
    // Reload the page to reflect original permissions
    window.location.reload()
  } finally {
    isEndingImpersonation.value = false
  }
}
</script>

<style scoped>
/* The runner as a card like the profile card: the same 44px height, 8px radius and padding, its colour the pill's. */
.sidebar-runner-card {
  margin-bottom: 4px;
}

.sidebar-runner-card :deep(.claude-runner-card__shell) {
  width: 100%;
  height: 44px;
  padding: 0 8px;
  gap: 4px;
  border-radius: 8px;
}

.sidebar-runner-card :deep(.claude-runner-card__button) {
  flex: 1;
  height: 100%;
  border-radius: 8px;
}

/* The button sits where the profile's avatar does, at its size. */
.sidebar-runner-card :deep(.claude-runner-card__controls .claude-runner-card__control) {
  width: 24px !important;
  min-width: 24px !important;
  height: 24px !important;
}

.sidebar-runner-card :deep(.wasabi-pill.static.small) {
  height: 44px !important;
  padding-left: 4px !important;
}

/* Not running, it is the profile card's own grey, darkening on hover as that card does. */
.sidebar-runner-card :deep(.claude-runner-card__shell:is([data-state='off'], [data-state='starting'])) {
  background-color: v-bind('colors.neutral.neutral100') !important;
  transition: background-color 0.2s ease;
}

.sidebar-runner-card :deep(.claude-runner-card__shell:is([data-state='off'], [data-state='starting']):hover) {
  background-color: v-bind('colors.neutral.neutral200') !important;
}

/* The label reads as the profile's email does. */
.sidebar-runner-card :deep(.claude-runner-card-face__label) {
  font-size: 12px !important;
  font-weight: 600 !important;
  line-height: 18px !important;
}

.sidebar-runner-card :deep(.claude-runner-card__shell:is([data-state='off'], [data-state='starting'])) {
  color: v-bind('colors.neutral.neutral1000') !important;
}

/* Collapsed to icons, centred like the profile's avatar. Off and starting keep their start/cancel control alone. */
.sidebar-runner-card-collapsed :deep(.claude-runner-card__shell) {
  justify-content: center;
  width: 40px;
  margin: 0 auto;
}

.sidebar-runner-card-collapsed :deep(.claude-runner-card__shell:is([data-state='off'], [data-state='starting']) .claude-runner-card__button) {
  display: none;
}

/* A live runner keeps its menu: the face stays as the icon (the warning one, when attention) and the controls go. */
.sidebar-runner-card-collapsed :deep(.claude-runner-card__shell:is([data-state='running'], [data-state='attention']) .claude-runner-card__controls),
.sidebar-runner-card-collapsed :deep(.claude-runner-card__shell:is([data-state='running'], [data-state='attention']) .claude-runner-card-face__label) {
  display: none;
}

/* Lock app to viewport - nav stays fixed, content scrolls */
:deep(.v-application) {
  height: 100vh;
  overflow: hidden;
}

:deep(.v-main) {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Sidebar Styling - Modern Light Theme with Collapse */
.adx-sidebar {
  border-right: 1px solid #e5e5e5 !important;
  transition: width 0.3s ease;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Sidebar header - logo centered when expanded, toggle centered when collapsed */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  min-height: 72px;
}

.sidebar-header-collapsed {
  padding: 16px 8px;
}

.sidebar-logo {
  display: flex;
  align-items: center;
}

.sidebar-logo-image {
  height: 36px;
  width: auto;
  max-width: 100%;
}

/* Logo fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Navigation List */
.nav-list {
  padding: 0;
}

/* Nav toggle button */
.nav-toggle-btn {
  color: rgb(var(--v-theme-primary)) !important;
  flex-shrink: 0;
}

/* Hide content when collapsed */
:deep(.adx-sidebar .v-navigation-drawer__content) {
  overflow-x: hidden;
}

/* Sidebar bottom section */
.sidebar-bottom {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Profile card - matches merchant-dashboard SideNav.vue */
.profile-button-card {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 8px;
  border-radius: 8px;
  background-color: #f9f9f9;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
  user-select: none;
}

.profile-button-card:hover {
  background-color: #e5e5e5;
}

.profile-button-card:active {
  background-color: #d9d9d9;
}

.profile-button-card-collapsed {
  justify-content: center;
  padding: 0 8px;
  width: 40px;
  margin: 0 auto;
}

.profile-avatar {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 9999px;
  background-color: #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: #353535;
}

.profile-email {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: #353535;
  text-align: left;
}

/* ─── DS SidebarItems — clean custom nav, no Vuetify overrides ─── */

/* Base nav item: button reset + shared DS values */
.nav-item {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
  /* Always reserve 4px left for the brand border — transparent when inactive */
  border: 0;
  border-left: 4px solid transparent;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #353535;
  transition: background-color 0.15s ease;
  outline: none;
}

/* Top-level item: 40px, 16px right, 12px left (12+4border = 16px visual) */
.nav-item-top {
  height: 40px;
  padding: 0 16px 0 12px;
  gap: 8px;
}

/* Nested item: 32px, 24px visual left (20px+4border), gray bg */
.nav-item-nested {
  height: 32px;
  padding: 0 16px 0 20px;
  background-color: #f9f9f9;
}

.nav-item-badge {
  margin-left: auto;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background: rgb(var(--env-color));
  color: white;
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
}

/* Hover: env-tinted on white */
.nav-item-top:hover {
  background-color: rgba(var(--env-color), 0.05);
}

/* Hover: blue tint over gray base (pre-blended) */
.nav-section-heading {
  padding: 10px 16px 2px 20px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-content-text-muted, #767676);
  background-color: #f9f9f9;
}

.nav-item-nested:hover {
  background-color: rgb(237, 242, 248);
}

/* Active: env-color left border + bold weight */
.nav-item.nav-item-active {
  border-left-color: rgb(var(--env-color));
  font-weight: 600;
  background-color: #ffffff;
}

/* Keyboard focus */
.nav-item:focus-visible {
  outline: 2px solid rgb(var(--env-color));
  outline-offset: -2px;
}

/* Icon inside nav items */
.nav-item-icon {
  flex-shrink: 0;
  color: #353535 !important;
}

/* Label: fills remaining space, truncates */
.nav-item-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Chevron: auto-margin pushes it right, rotates when open */
.nav-item-chevron {
  flex-shrink: 0;
  color: #353535 !important;
  transition: transform 0.2s ease;
  margin-left: auto;
}

.nav-item-chevron-open {
  transform: rotate(180deg);
}

/* Collapsed mode: icon-only centered button */
.nav-item-collapsed {
  width: 40px;
  height: 40px;
  padding: 0;
  border-left: none;
  justify-content: center;
  margin: 0 auto;
  border-radius: 4px;
}

.nav-item-collapsed.nav-item-active {
  border-left: none;
  background-color: rgba(var(--env-color), 0.1);
}

/* Remove border from toast notifications */
:deep(.wasabi_toast .v-alert) {
  border: none !important;
}

/* Color picker styles */
.color-picker-item {
  min-height: 56px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.color-swatches {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 140px;
  margin-left: 16px;
  padding: 4px;
}

.color-swatch {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0;
}

.color-swatch:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.color-swatch-selected {
  border-color: #333 !important;
  box-shadow: 0 0 0 2px white inset;
}

.duration-toggle {
  height: 24px;
}

.duration-toggle .v-btn {
  min-width: 32px !important;
  padding: 0 6px !important;
}

/* Version footer styling */
.version-footer {
  text-align: center;
  padding-bottom: 8px;
}

.version-footer-collapsed {
  display: none;
}

.version-text {
  font-size: 10px;
  color: #ccc;
  font-family: monospace;
  letter-spacing: 0.3px;
}

/* Admin Impersonation Banner - sticky at top of scroll area */
.admin-impersonation-banner {
  position: sticky;
  top: 0;
  z-index: 1005;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.admin-impersonation-banner :deep(.v-banner__content) {
  padding-top: 8px;
  padding-bottom: 8px;
}

/*
 * Tonal wash, one rule per environment: a muted background wash under saturated
 * text/icon, rather than a solid theme-colour fill. v-banner has no `variant` prop
 * (bgColor only ever paints solid), so the wash lives here instead of on a Vuetify prop.
 * `--v-theme-*` are Vuetify's own RGB-channel custom properties.
 */
.admin-impersonation-banner--success {
  background-color: rgba(var(--v-theme-success), 0.12);
  color: rgb(var(--v-theme-success));
}

.admin-impersonation-banner--warning {
  background-color: rgba(var(--v-theme-warning), 0.12);
  color: rgb(var(--v-theme-warning));
}

.admin-impersonation-banner--error {
  background-color: rgba(var(--v-theme-error), 0.12);
  color: rgb(var(--v-theme-error));
}

/* Sidebar border toggle - circle sitting on the right edge of the expanded sidebar */
.sidebar-border-toggle {
  position: fixed !important;
  /* 211px sidebar width, button ~32px wide → left = 211 - 16 = 195px */
  left: 195px !important;
  /* 72px header height, button ~32px tall → top = (72 - 32) / 2 = 20px */
  top: 20px !important;
  z-index: 1100 !important;
  background-color: white !important;
  border: 1px solid #e5e5e5 !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  padding: 0 !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1) !important;
  color: rgb(var(--v-theme-primary)) !important;
}
.sidebar-border-toggle:hover {
  background-color: white !important;
}
.sidebar-border-toggle :deep(.v-btn__overlay) {
  opacity: 0 !important;
}

/* Takes the floating buttons' WButton wrappers out of the page flow; the buttons themselves are fixed. */
.floating-controls {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
}

/* Hidden until focused, then the first thing on screen. */
.skip-link {
  position: absolute;
  left: 8px;
  top: -48px;
  z-index: 2000;
  padding: 8px 12px;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.skip-link:focus {
  top: 8px;
}

#main-content:focus {
  outline: none;
}

/* Mobile floating menu button */
.mobile-menu-btn {
  position: fixed !important;
  top: 12px;
  left: 12px;
  z-index: 1000;
  background-color: white !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}
</style>
